import React from 'react';

export default function AddressPointIcon({ width = 50, height = 60, color = 'currentColor', ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      // stroke={color}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
    {/* Icono globito de ubicación SVG */}
      <path d="M12 2C7.03 2 3 6.03 3 11c0 5.25 7.11 10.45 8.09 11.16.34.25.82.25 1.16 0C13.89 21.45 21 16.25 21 11c0-4.97-4.03-9-9-9zm0 17.88C9.14 17.1 5 13.61 5 11c0-3.87 3.13-7 7-7s7 3.13 7 7c0 2.61-4.14 6.1-7 8.88z" fill="rgb(197, 20, 20)"/>
      <circle cx="12" cy="11" r="3" fill="#c41414"/>
    </svg>
  );
}
